<router-outlet></router-outlet>
<div *ngIf="customLoader" style="position: fixed;background-color:  rgba(0,0,0,.32);left: 0;top: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 9999999;">
    <!-- <span class="spinner"></span> -->
    <span  class="spinner"></span>
    
  </div>

<app-cookie-accept-modal #cookieAcceptModal></app-cookie-accept-modal>